import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { servicesHomePage } from "i18n/homePage";
import CTAButton from "Util/CTAButton";
import { Info, LayoutDashboard } from "lucide-react";

const Services = () => {
  const navigate = useNavigate();

  const lang = useSelector((state) => state.language.lang);
  const t = servicesHomePage[lang];

  return (
    <section className="relative w-full  overflow-hidden bg-[#0d0d0d] py-20 lg:py-28">
      {/* Background Image */}
      {/* Content */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-reddark/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-500/10 rounded-full blur-[120px]" />
      </div>{" "}
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="
              relative
              rounded-[32px]
              border border-white/10
              bg-white/[0.03]
              backdrop-blur-xl
              p-0 md:p-16
              text-center
              overflow-hidden
            "
        >
          {" "}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-reddark via-red-500 to-reddark" />
          <div className="relative z-10 flex flex-col items-center justify-center text-center  px-0 py-16 ">
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="flex items-center gap-4 mb-6"
            >
              <span className="w-12 h-px bg-reddark" />
              <span className="uppercase tracking-[0.3em] text-sm text-white/80 font-medium">
                {t.titleTop}
              </span>
              <span className="w-12 h-px bg-reddark" />
            </motion.div>

            <motion.h1
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="
      font-[Crimson]
      text-white
      text-4xl md:text-6xl lg:text-7xl
      leading-[0.95]
      uppercase
      max-w-6xl
      mb-8
      drop-shadow-[0_10px_30px_rgba(0,0,0,0.35)]
    "
            >
              {t.title.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </motion.h1>

            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="w-24 h-1 bg-reddark rounded-full mb-8"
            />

            <motion.p
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              transition={{ delay: 0.2 }}
              className="
      max-w-4xl
      text-white/70
      leading-relaxed
      tracking-wide
      mb-12
    "
            >
              {t.subtitle}
            </motion.p>

            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <CTAButton
                variant="primary"
                icon={Info}
                text={t.button}
                onClick={() => navigate("/services")}
              />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
